export default __webpack_public_path__ + "static/media/merchant-logo.1bb1a4fa.png";